<mat-tab-group [selectedIndex]="CurrentIndex" (selectedIndexChange)="tabChanged($event)">
  <ng-container *ngFor="let tab of tabs; let index = index">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="hearder">
          <div class=" tabHeading">
            <div class="mynew">
              <span _ngcontent-bsl-c5="" class="list-icon heading-icon"
                [ngClass]="{'feature': tab._type=='feature',' scenario': tab._type=='scenario','step': tab._type=='step'}"></span>
              <div class="name">
                {{tab.mainHeadingName}}
              </div>
            </div>
          </div>
          <button class="crossBtn" mat-icon-button (click)="closeTab(index)">
            <mat-icon class="myicon">close</mat-icon>
          </button>
        </div>
      </ng-template>
      <div cdkDropList [cdkDropListData]="tab.model" class="list" (cdkDropListDropped)="drop($event)"
        cdkDropListConnectedTo="connectedList()">
        <span class="list-container">
          <span class="material-icons save-btn" (click)="saveCanvas()" (click)="openSnackBar()">save</span>
          <span class="material-icons save-btn" (click)="saveAsCanvas()" (click)="openSnackBar()">file_copy</span>
          <ng-container *ngFor="let item of tab.model;let i = index">
            <div class="box" cdkDrag *ngIf="item.deleted==0">
              <span _ngcontent-bsl-c5="" class="list-icon "
                [ngClass]="{'feature': item.model._type=='feature',' scenario': item.model._type=='scenario','step': item.model._type=='step'}"></span>
              <span class="listName">{{item.model.name}}</span>
              <span class="material-icons" (click)="delete(item,i )">delete</span>
            </div>
          </ng-container>
        </span>
      </div>
    </mat-tab>
  </ng-container>
</mat-tab-group>